import React from "react"
// import './BulkSMS.css'  
import monitoringTheDeviation from '../../assets/images/monitoringTheDeviation.webp'
import bulkSMS from '../../assets/images/bulkSMS.jpg'

import targetedApproach from '../../assets/images/targetedStrategies.jpg'
import advancedTechnology from '../../assets/images/advamcedTechnology.jpg'
import provenTrackRecord from '../../assets/images/provenTrackRecord.jpg'

import audienceSelection from '../../assets/images/targetedCampaign.jpg'
import deliveryAndTracking from '../../assets/images/continuousMonitoringAndImprovement.jpg'
import messageCreation from '../../assets/images/messageCreation.jpg'

import { Link } from "react-router-dom"

export default function BulkSMS(){
    return(
        <div className="bulkSMS">
            {/* <ServicesNav/> */}
            <BSR1/>
            <BSR2/>
            <BSR3/>
            <BSR4/>
            <ContactSection/>
            {/* this contact section's css is in social media marketing page's css file */}
        </div>
    )
}

function BSR1(){
    return(
        <div className='bsr1'>
            <img loading="lazy" src={bulkSMS} alt='bs-banner' className='bs-banner-img'/>
            <h1 className='bsr1-head'>Bulk SMS</h1>
            <div className='overlay'></div>
        </div>
    )
}

function BSR2(){
    return(
        <div className='bsr2'>
            <div className='strip'>
                <h1>What Is <span>Bulk SMS</span>?</h1>
                <hr/>   
                <p>Bulk SMS, or Bulk Short Message Service, is a powerful tool in digital marketing, allowing businesses to send large volumes of text messages to their target audience simultaneously. This method enables direct and immediate communication with customers, enhancing engagement and promoting brand awareness.</p>
            </div>
        </div>
    )
}

function BSR3(){
    return(
        <div className='bsr3'>
            <div className='rowThreeContainer'>
                <h1 className='rowThreeHead'>
                Why <span>Choose Bixian</span> for Bulk SMS?
                </h1>
                <p className='rowThreeContext'>
                Bixian emerges as the top choice for Bulk SMS services, offering unparalleled expertise and comprehensive solutions. With our dedicated approach, advanced technology, and commitment to excellence, we deliver results that exceed expectations.
                </p>
                <div className='rowThreeBoxes'>
                    {/* box 1 */}
                    <div className='box boxOne'>
                        <div className='context'>
                            <img loading="lazy" src={targetedApproach} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Targeted Approach
                            </h2>
                            <p className='boxPara'>
                            Bixian adopts a targeted approach to Bulk SMS, ensuring that your messages reach the right audience at the right time, leading to higher engagement and conversion rates.
                            </p>
                        </div>
                    </div>
                    {/* box 2 */}
                    <div className='box boxTwo'>
                        <div className='context'>
                            <img loading="lazy" src={advancedTechnology} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Advanced Technology
                            </h2>
                            <p className='boxPara'>
                            Leveraging cutting-edge technology and innovative tools, we optimize the delivery and performance of your Bulk SMS campaigns, maximizing their effectiveness and impact.
                            </p>
                        </div>
                    </div>
                    {/* box 3 */}
                    <div className='box boxThree'>
                        <div className='context'>
                            <img loading="lazy" src={provenTrackRecord} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Proven Track Record
                            </h2>
                            <p className='boxPara'>
                            With a proven track record and a portfolio of satisfied clients, Bixian shows its ability to deliver results and drive business growth through Bulk SMS marketing.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

function BSR4(){
    return(
        <div className='bsr4'>
            <div className='rowFourContainer'>
                <div className='rowFourContext'>
                    <h1 className='rowFourHead'>Our Process</h1>
                    <p className='rowFourPara'>
                    Experience the power of Bulk SMS Marketing with Bixian's systematic approach. Our process is designed to deliver impactful messaging campaigns that resonate with your audience, drive engagement, and yield measurable results.
                    </p>
                </div>
                <div className='rowFourBoxes'>
                    <div className='box boxOne'>
                            <img loading="lazy" src={audienceSelection} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Audience Selection</h2>
                        <p className='boxPara'>We analyze your target audience to tailor messages for maximum relevance and impact.</p>
                    </div>
                    <div className='box boxTwo'>
                            <img loading="lazy" src={messageCreation} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Message Creation</h2>
                        <p className='boxPara'>Our team crafts compelling messages that communicate your brand and call-to-action effectively.</p>
                    </div>
                    <div className='box boxThree'>
                            <img loading="lazy" src={deliveryAndTracking} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Delivery and Tracking</h2>
                        <p className='boxPara'>We execute campaigns with precise timing, tracking delivery and engagement to measure success.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss More About Our Bulk SMS Marketing?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}